import type { ReactElement } from "react";
import { useState } from "react";
import { Navigate } from "react-router-dom";

import { useAppSelector } from "store/hooks";
import { selectOnboardingFinished } from "store/slices/user";

/**
 * AIDEV-NOTE: AuthenticatedArea posílá do onboardingu jen nedokončené studenty, opačným směrem
 * nehlídá nic. Dokončený student, který otevře onboarding přímo (záložka, obnovená karta,
 * historie), by ho bez guardu prošel celý znovu. Rozhoduje stav při vstupu na routu: výsledky
 * ukázky onboarding dokončují samy a student z nich odchází až po tipech. Stav se bere ze store,
 * ne z cache dotazu: reset onboardingu na /dev mění jen store. [TD-490]
 */
export const OnboardingGuard = ({ children }: { children: ReactElement }) => {
  const isFinished = useAppSelector(selectOnboardingFinished);
  const [wasFinishedOnEntry] = useState(isFinished);

  if (wasFinishedOnEntry) return <Navigate to="/" replace />;

  return children;
};
